import React from "react";
import { DataProvider } from "./DataContext";
import AppWrapper from "./components/AppWrapper";
import LogRocket from "logrocket";
if (process.env.NODE_ENV === "production") {
  console.log("LogRocket enabled");
  LogRocket.init("gzudjp/the-v-simulator");
} else {
  console.log("LogRocket disabled");
}

const App = () => {
  return (
    <DataProvider>
      <AppWrapper />
    </DataProvider>
  );
};

export default App;
